import { AI_REWRITE_CONTENT } from './aiRewrite';
import { AUDIO_DOWNLOAD_CONTENT } from './audioDownload';
import { DOWNLOAD_CONTENT } from './download';
import { GLOSSARY_CONTENT } from './glossary';
import { LIP_SYNC_CONTENT } from './lipSync';
import { MULTILANGUAGE_CONTENT } from './multilanguage';
import { SRT_DOWNLOAD_CONTENT } from './srtDownload';
import { SRT_UPLOAD_CONTENT } from './srtUpload';
import { SUBTITLE_EXPORT_CONTENT } from './subtitleExport';
import { TEAMSPACE_CONTENT } from './teamspace';
import { TRANSLATION_DICTIONARY_CONTENT } from './translationDictionary';
import { TRANSLATION_TONE_CONTENT } from './translationTone';
import { UNLIMITED_LENGTH_CONTENT } from './unlimitedLength';
import { USER_PROMPTING_CONTENT } from './userPrompting';
import { VIDEO_SUBTITLES_CONTENT } from './videoSubtitles';
import { VOICE_PRESETS_CONTENT } from './voicePresets';

export const CONTENT = {
  aiRewrite: AI_REWRITE_CONTENT,
  audioDownload: AUDIO_DOWNLOAD_CONTENT,
  download: DOWNLOAD_CONTENT,
  glossary: GLOSSARY_CONTENT,
  lipSync: LIP_SYNC_CONTENT,
  multilanguage: MULTILANGUAGE_CONTENT,
  srtDownload: SRT_DOWNLOAD_CONTENT,
  srtUpload: SRT_UPLOAD_CONTENT,
  subtitleExport: SUBTITLE_EXPORT_CONTENT,
  teamspace: TEAMSPACE_CONTENT,
  translationDictionary: TRANSLATION_DICTIONARY_CONTENT,
  translationTone: TRANSLATION_TONE_CONTENT,
  unlimitedLength: UNLIMITED_LENGTH_CONTENT,
  userPrompting: USER_PROMPTING_CONTENT,
  videoSubtitles: VIDEO_SUBTITLES_CONTENT,
  voicePresets: VOICE_PRESETS_CONTENT,
};
